module.exports = __webpack_public_path__ + "fonts/CircularStd-Book.bdf1b461.woff";